export const requiredMessage = "This is a required field";
export const stringMessage = "Please enter a string";
export const emailMessage = "Please enter a valid email";
